import useTranslations from '@/widgets/hooks/useTranslations';
import type { FiltersAndSort } from '@/widgets/services/FilteringAndSortingService';

type UseProductListTitleProps = {
  filtersAndSort: FiltersAndSort;
};

export default function useProductListTitle({
  filtersAndSort
}: UseProductListTitleProps): string {
  const { t } = useTranslations();
  const isFiltering = filtersAndSort.filtering.isFiltered.value;
  const isSorting = filtersAndSort.sorting.isSorted.value;
  let headingKey = '';

  if (!isFiltering && !isSorting) {
    return headingKey;
  }

  if (!isFiltering) {
    headingKey = 'withSort';
  }

  if (!isSorting) {
    headingKey = 'withFilter';
  }

  return t(
    `productList.filters.selections.${headingKey || 'withFilterAndSort'}`,
    {
      count: filtersAndSort.products.value.length,
      sort: filtersAndSort.sorting.currentSort.value?.label
    }
  );
}
